module.exports = {
    orderConfirmation: {
        pickupMessage: 'Your order can be collected from',
        deliveryMessage: 'Your order will be delivered to',

        orderConfirmedMessage: 'Order confirmed',
        orderCancelledMessage: 'Order cancelled',

        orderConfirmedAdditionalMessage: 'Thanks for shopping with Woolworths!',
        orderCancelledAdditionalMessage: 'The order value will be refunded to you soon!',

        // For the delivery details section header
        courierDeliveryDetailsHeader: 'DELIVERY ORDER DETAILS',
        expressDeliveryDetailsHeader: 'YOUR ORDER WILL BE DELIVERED',
        pickupDeliveryDetailsHeader: 'PICK UP ORDER DETAILS',

        // For the order confirmation header
        courierOrderConfirmationHeader: 'Delivery',
        expressDeliveryOrderConfirmationHeader: 'Delivery Now',
        pickupDeliveryOrderConfirmationHeader: 'Pick up',

        // Different delivery methods for the order
        courierDeliveryMethod: 'Courier',
        expressDeliveryMethod: 'XpressD',
        pickupDeliveryMethod: 'Pickup',
        hubspokDeliveryMethod: 'HubSpok',

        // Payment Breakdown Key
        creditCardKey: 'CreditCard',
        paypalKey: 'PayPal',
        giftCardKey: 'GiftCard',

        // Order Save to List
        saveToListHeading: 'Save time shopping',
        saveToListContent: 'Don\'t build your basket from scratch: save your order to Lists and add it straight to the cart in one click next time. <br/><br/>Shop faster with Lists.',
        saveToListError: 'Sorry, something went wrong.',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/order-confirmation.js